/**
 * A helper functtion to generate a random funnel ID.
 *
 * To be used in cases where there is no ID available for analytics that are flow/funnel based, e.g <>_started, <>_more_events, <>_completed, etc.
 */
export function generateRandomFunnelID(length = 8) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;

    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
}

/**
 * Convert a billing amount from the GitBook API or Stripe to a value suitable for Amplitude.
 */
export function convertBillingAmountToAnalyticsAmount(amount: number): number {
    // Billing amounts are in cents. Convert to dollars.
    return amount / 100;
}
